import { render, staticRenderFns } from "./FontFileUpload.vue?vue&type=template&id=3a285e30&"
import script from "./FontFileUpload.vue?vue&type=script&lang=ts&"
export * from "./FontFileUpload.vue?vue&type=script&lang=ts&"
import style0 from "./FontFileUpload.vue?vue&type=style&index=0&id=3a285e30&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports